

import $ from 'jquery'; 

$(document).ready(() => {

     $('video').attr('controlsList', 'nodownload');
     
     });